<div class="container-modal">
  <div>
    <span class="modal-title">facility point {{FP}}</span>
  </div>
  <div>
    <span class="modal-point-name">Silo 1</span>
  </div>
  <div>
    <hr>
  </div>
  <div class="history-truck">
    <div class="list-detail-plates">
      <div class="modal-plate">
        <div>
          <span>LP.</span>
          &nbsp;
          <span class="modal-lp-number modal-plate-danger">#00000</span>
        </div>
        <div>
          <span class="modal-view-multi" (click)="getDetail()">View detail</span>
        </div>
      </div>
    </div>
    <div class="detail-information" *ngIf="response!==null">
      <div class="detail-information-header">
        <div>
          <span class="title-dih">Detail Information</span>
        </div>
        <div class="detail-information-header-first">
          <div class="contain-text-dihf">
            <div class="lisence-plate">Lisence Plate: {{plateNumber}}</div>
            <div class="text-plate">Completed trips today: {{amountOfJourneys}}</div>
          </div>
          <div class="contain-text-dihf">
            <div class="text-plate">Plant: {{plant}}</div>
            <div class="text-plate">Avg time of completed trips today: {{AvgTime}}</div>
          </div>
        </div>
      </div>
      <div>
        <hr>
      </div>
      <div class="detail-information-gallery">
        <div>
          <span class="text-plate">Image from: </span>
          <span class="lisence-plate">Silo #1</span>
        </div>
        <div>
          <img #image src="" alt="">
        </div>
        <div class="sub-images">
          <div>
            <cwc-pagination #pagination active-page="1" (cwcChange)="cwcChange($event)"></cwc-pagination>
          </div>
          <div class="expand-download">
            <div>
              <span>Expand Image</span>
            </div>
            &nbsp;
            &nbsp;
            <div>
              <span>Download all</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <hr>
      </div>
      <div class="detail-information-details">
        <div class="did-item">
          <cwc-card class="p16">
            <span class="text-status">Everything in order.</span>
          </cwc-card>
        </div>
        <div class="did-item edit-plate">
          <div>
            <cwc-input class="width-full" label="Lisence Plate" loading="false" trailing-icon="magnifier-glass"
              placeholder="#000000"></cwc-input>
          </div>
          &nbsp;
          &nbsp;
          <div>
            <cwc-button>Edit</cwc-button>
          </div>
        </div>
        <div class="did-item truck-path-detail">
          <div>
            <span class="title-dih">Truck Path</span>
          </div>
          <div class="grid-truck-path">
            <div class="item-grid-truck-path nombre">
              <div class="item-nombre">
                <span class="title-points">Facility Point</span>
              </div>
              <div class="item-nombre">
                <span class="title-points">Total Tons</span>
              </div>
              <div class="item-nombre">
                <span class="title-points">Time</span>
              </div>
              <div class="item-nombre">
                <span></span>
              </div>
            </div>
            <div class="item-grid-truck-path barra">
              <div class="item-barra">
                <div class="bolita"></div>
              </div>
              <div class="item-barra">
                <div class="bolita"></div>
              </div>
              <div class="item-barra">
                <div class="bolita"></div>
              </div>
              <div class="item-barra">
                <div class="bolita"></div>
              </div>
            </div>
            <div class="item-grid-truck-path points">
              <div class="fp-ld">
                <div class="text-points">Entrance</div>
                <div class="text-points"></div>
                <div class="text-points"></div>
                <div class="link-points">View Image</div>
              </div>
              <div class="fp-ld">
                <div class="text-points">Yard</div>
                <div class="text-points">0000</div>
                <div class="text-points">00:00:00</div>
                <div class="link-points">View Image</div>
              </div>
              <div class="fp-ld">
                <div class="text-points">Silo # 1</div>
                <div class="text-points">0000</div>
                <div class="text-points">00:00:00</div>
                <div class="link-points">View Image</div>
              </div>
              <div class="fp-ld">
                <div class="text-points">Exit Guard</div>
                <div class="text-points"></div>
                <div class="text-points"></div>
                <div class="link-points">View Image</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
